import { render, staticRenderFns } from "./recommend-cate-dialog.vue?vue&type=template&id=fc83fbb4&"
import script from "./recommend-cate-dialog.vue?vue&type=script&lang=js&"
export * from "./recommend-cate-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "recommend-cate-dialog.vue"
export default component.exports